import { ENV } from '~/utils/env';
import { isServer } from '~/utils/ssr';

export const ASSIGN_CASHNOTE_PLUS_URL = () => {
  if (isServer()) return '';

  return ENV === 'dev'
    ? `https://dev-app.cashnote.kr/cashnote-plus/api/precheck?referrer=market&postAction=quit&source=market_${window.location.pathname}`
    : `https://app.cashnote.kr/cashnote-plus/api/precheck?referrer=market&postAction=quit&source=market_${window.location.pathname}`;
};

export const PLUS_MEMBERSHIP_SHOWCASE_GROUP_CODE = 'plusmem_crm_group';
export const PLUS_MEMBERSHIP_SHOWCASE_CODE = 'm_sale';

export const BUSINESS_CARD_CHECKOUT_URL =
  'https://finance.cashnote.kr/finance/recommend-card/promotion/cashnote-hyundai?utm_source=banner&utm_medium=checkout&utm_campaign=market';

export const BUSINESS_CARD_PRODUCT_URL =
  'https://finance.cashnote.kr/finance/recommend-card/promotion/cashnote-hyundai?utm_source=banner&utm_medium=product&utm_campaign=market';

export const BUSINESS_CARD_COUPON_URL =
  'https://finance.cashnote.kr/finance/recommend-card/promotion/cashnote-hyundai?utm_source=banner&utm_medium=coupon&utm_campaign=market';

export const PLUS_MEMBERSHIP_STANDARD_JOIN_URL =
  ENV === 'dev'
    ? 'https://dev-app.cashnote.kr/cashnote-plus/landing?alias=marketprice-standard-free'
    : 'https://app.cashnote.kr/cashnote-plus/landing?alias=marketprice-standard-free';

export const PLUS_MEMBERSHIP_FREE_TRIAL_JOIN_URL =
  ENV === 'dev'
    ? 'https://dev-app.cashnote.kr/cashnote-plus/landing?alias=marketprice-standard-free'
    : 'https://app.cashnote.kr/cashnote-plus/landing?alias=marketprice-standard-free';

export const PLUS_MEMBERSHIP_BONUSPACK_JOIN_URL =
  ENV === 'dev'
    ? 'https://dev-app.cashnote.kr/cashnote-plus/landing?alias=market-lucky-bonuspack-joined'
    : 'https://app.cashnote.kr/cashnote-plus/landing?alias=market-lucky-bonuspack-joined';

export const PLUS_MEMBERSHIP_BIG_SALE_JOIN_URL =
  ENV === 'dev'
    ? 'https://dev-app.cashnote.kr/cashnote-plus/landing?alias=market-standard-free&utm_source=market_banner&utm_medium=crosstraffic&utm_campaign=2409_plusmembership_standard&utm_content=market-big-sale'
    : 'https://app.cashnote.kr/cashnote-plus/landing?alias=market-standard-free&utm_source=market_banner&utm_medium=crosstraffic&utm_campaign=2409_plusmembership_standard&utm_content=market-big-sale';

// 플멤 5% 중복할인 이벤트 localStoage key값
export const PLUS_MEMBERSHIP_EVENT = 'plus-membership-tutorial';

/**
 * 빅세일 프로모션 / 플멤위크 중 빅세일 프로모션이 진행 여부
 *
 * 4월만 IS_BIG_SALE로 하드코드딩하여 진행, 5월 부턴 빅세일 프로모션 타입 추가하여 진행 예정.
 * 이슈 스레드: https://koreacreditdata.slack.com/archives/C079PTR67HT/p1775720217282989?thread_ts=1775720090.526059&cid=C079PTR67HT
 *
 * 추후 제거 시 IS_BIG_SALE을 모두 priceBadge === {빅세일 타입}으로 교체하면 됨.
 */
export const IS_BIG_SALE = false;
